import { createAction } from '@reduxjs/toolkit'
import { ActionTypes_Report } from './TActions'
import { IDetailedReport, IHeatmapReport, TInvoicesFilter, TReport, TReportFilter, TReportFilterUser } from './TReducer'
import { TStoreTemplateWithFilter } from 'redux/config/root-types'

const { SagaEvents, StoreActions } = ActionTypes_Report

export const Actions_report = {
  saga: {
    getReport: createAction(SagaEvents.GET_REPORT),
    getDetailedReport: createAction(SagaEvents.GET_DETAILED_REPORT),
    getUserReport: createAction<{ userId: string }>(SagaEvents.GET_USER_REPORT),
    getDetailedReportTotalCost: createAction(SagaEvents.GET_DETAILED_REPORT_TOTAL_COST),
    loadPage: createAction(SagaEvents.LOAD_PAGE),
    loadXlsx: createAction(SagaEvents.LOAD_XLSX),
    loadDetailedXlsx: createAction(SagaEvents.LOAD_DETAILED_XLSX),
    loadDetailedUserReportXlsx: createAction<{ userId: string }>(SagaEvents.LOAD_DETAILED_USER_REPORT_XLSX),
    loadCsv: createAction<{ type?: 'refund' }>(SagaEvents.LOAD_CSV),
  },

  store: {
    showLoader: createAction(StoreActions.IS_LOADER_SHOW),
    hideLoader: createAction(StoreActions.IS_LOADER_HIDE),
    saveReport: createAction<TStoreTemplateWithFilter<TReport>>(StoreActions.SAVE_REPORT),
    saveDetailedReportRents: createAction<{ rents: IDetailedReport[]; isAllInvoicesDataLoaded: boolean }>(
      StoreActions.SAVE_DETAILED_REPORT_RENTS,
    ),
    saveDetailedReportRentsTotalCost: createAction<number>(StoreActions.SAVE_DETAILED_REPORT_TOTAL_COST),
    saveHeatmapReports: createAction<IHeatmapReport[]>(StoreActions.SAVE_HEATMAP_REPORTS),
    changeFilter: createAction<TReportFilter>(StoreActions.CHANGE_FILTER),
    increaseFilterOffset: createAction<TReportFilter>(StoreActions.INCREASE_FILTER_OFFSET),
    increaseInvoiceFilterOffset: createAction<TInvoicesFilter>(StoreActions.INCREASE_INVOICE_FILTER_OFFSET),
    increaseUserReportFilterOffset: createAction<TInvoicesFilter>(StoreActions.INCREASE_USER_REPORT_FILTER_OFFSET),
    setInvoiceFilter: createAction<TInvoicesFilter>(StoreActions.SET_INVOICE_FILTER),
    resetInvoiceFilter: createAction(StoreActions.RESET_INVOICE_FILTER),
    setInvoiceNumberInInvoiceFilter: createAction<string>(StoreActions.SET_INVOICE_NUMBER_IN_INVOICE_FILTER),
    openDetailedTable: createAction(StoreActions.OPEN_DETAILED_TABLE),
    closeDetailedTable: createAction(StoreActions.CLOSE_DETAILED_TABLE),
    choosenTurnOver: createAction(StoreActions.CHOOSEN_TURN_OVER),
    changedTurnOver: createAction(StoreActions.CHANGED_TURN_OVER),
    reset: createAction(StoreActions.RESET),
  },
}
